import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "native-base";
import { useMemo } from "react";
import InsulinReminderTable from "../../organisms/InsulinReminderTable";
import useResponsive from "../../util/useResponsive";
import ListHeader from "../../molecules/ListHeader";
import Paper from "../../atoms/Paper";
import InsulinReminderContentMobile from "./InsulinReminderContentMobile";
const DesktopLayout = ({ sections, onDeletePress, onEditPress, }) => {
    const lastIndex = sections.length - 1;
    return (_jsx(_Fragment, { children: sections.map((section, index) => {
            var _a;
            return (_jsxs(Box, Object.assign({ width: "full", px: 6, py: 4, borderBottomColor: index === lastIndex ? "transparent" : "gray.100", borderBottomStyle: "solid", borderBottomWidth: 1, marginBottom: index === lastIndex ? 0 : 3 }, { children: [_jsx(ListHeader, { title: section.header.title, badge: section.header.badge, variant: "inverted", size: "md", px: 0, pt: 0, pb: 0 }), _jsx(InsulinReminderTable, { data: (_a = section === null || section === void 0 ? void 0 : section.data) !== null && _a !== void 0 ? _a : [], onDeletePress: onDeletePress, onEditPress: onEditPress })] }), `measurement-table-section-${index}`));
        }) }));
};
const weekdays = [
    "Vasárnap",
    "Hétfő",
    "Kedd",
    "Szerda",
    "Csütörtök",
    "Péntek",
    "Szombat",
];
const InsulinReminderList = ({ data, onDeletePress, onEditPress }) => {
    const { isSmallScreen } = useResponsive();
    // const { patient } = useCurrentPatient();
    const sections = useMemo(() => {
        const groupByDay = weekdays.map((day, index) => {
            const date = data.filter((item) => {
                //console.log("index", index, item?.daysOfWeek);
                const days = item === null || item === void 0 ? void 0 : item.daysOfWeek;
                return days === null || days === void 0 ? void 0 : days.includes(index);
            });
            return {
                header: {
                    title: day,
                    badge: date.length,
                },
                data: date.sort((a, b) => {
                    const aDate = new Date(a.firstOccurrence);
                    const bDate = new Date(b.firstOccurrence);
                    const aCompare = aDate.getHours() * 60 + aDate.getMinutes();
                    const bCompare = bDate.getHours() * 60 + bDate.getMinutes();
                    return aCompare - bCompare;
                }),
            };
        });
        return [...groupByDay.slice(1), groupByDay[0]];
    }, [data]);
    return (_jsx(Box, Object.assign({ width: "full" }, { children: _jsx(Paper, Object.assign({ borderTopLeftRadius: 0, borderTopRightRadius: 0, width: "full", borderWidth: 0 }, { children: isSmallScreen ? (_jsx(InsulinReminderContentMobile, { sections: sections, onDeletePress: onDeletePress, onEditPress: onEditPress })) : (_jsx(DesktopLayout, { sections: sections, onDeletePress: onDeletePress, onEditPress: onEditPress })) })) })));
};
export default InsulinReminderList;
